module.exports = __webpack_public_path__ + "static/media/search.62d192a5.svg";